<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
/deep/ .el-switch {margin-top: 18px;margin-left: 1400px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.title" placeholder="请输入关键词" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                  <el-button type="primary" @click="load()">导出</el-button>
                  <el-button type="primary" @click="loadAll()">全部导出</el-button>
                </div>
                  
              </el-form-item>
              <div>
                <el-switch
                    style="display: block"
                    v-model="value2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="报名开启"
                    inactive-text="报名关闭"
                    @change="switchClick">
                  </el-switch>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="类型" width="60">
              <template slot-scope="scope">{{ scope.row.type | typeData() }}</template>
          </el-table-column>
          <el-table-column prop="name" label="报名用户" width="100"></el-table-column>
          <el-table-column label="性别" width="115">
              <template slot-scope="scope">{{ scope.row.gender | genderData() }}</template>
          </el-table-column>
          <el-table-column prop="post" label="职务" width="115"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="115"></el-table-column>
          <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
          <el-table-column prop="company" label="单位"  width="150"></el-table-column>
          <el-table-column prop="address" label="单位地址"  width="150"></el-table-column>
          <el-table-column prop="industrycategory" label="行业类别"  width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="country" label="国家"  width="150"></el-table-column>
          <el-table-column prop="nums" label="人数" width="60"></el-table-column>
          <el-table-column prop="id" label="参会名单" width="150">
            <template slot-scope="scope">
              <el-button type="primary" @click="openJoin(scope.row)" >查看名单</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="names" label="会议名称" width="150"></el-table-column>
          <el-table-column prop="meetingtype" label="会议类型" width="150"></el-table-column>
          <el-table-column prop="addtime" label="报名时间" width="160">
              <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="资料上传" width="300">
            <template slot-scope="scope">
              <el-button type="primary" @click="openPicture(scope.row.thumb)" >图片</el-button>
              <el-button type="primary" @click="openVideo(scope.row.video)" >视频</el-button>
              <el-button type="primary" @click="openFile(scope.row.file)">文档</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="meetingdemand" label="参会需求" width="200"></el-table-column>
          <el-table-column prop="examine" label="审核状态" width="80">
              <template slot-scope="scope">{{ scope.row.examine | examine_datas() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="warning" @click="release(scope.row)" v-if="show1" :disabled='scope.row.examine !== 0'>通过</el-button>
              <el-button type="warning" @click="releases(scope.row)" v-if="show1" :disabled='scope.row.examine !==0 '>不通过</el-button>
              <el-button type="danger" @click="deletefn(11, 106, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 106)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>

    <el-dialog :visible.sync="dialogFormVisible">
    <el-form :model="form">
        <el-input
        type="textarea"
        placeholder="请输入理由（非必填）"
        v-model="form.passcontent">
        </el-input>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="release1">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogFormVisibles">
    <el-form :model="form">
        <el-input
        type="textarea"
        placeholder="请输入理由（非必填）"
        v-model="form.onpasscontent">
        </el-input>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibles = false">取 消</el-button>
        <el-button type="primary" @click="release2">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog title="参会名单" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="joinname" label="姓名" width="200"></el-table-column>
        <el-table-column property="joingender" label="性别" width="150"></el-table-column>
        <el-table-column property="joinpost" label="职务" width="200"></el-table-column>
        <el-table-column property="joinphone" label="手机号"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
/**
 * lx
 * 矿业论坛会议后台列表页
 */
import filters from '../method/filter'
import {mapState} from 'vuex'
export default {
  mixins: [filters],
  data()
  {
    return {
      form: {
        title: '',
        count: 10,
        passcontent: '',
        onpasscontent: ''
      },
      value2: true,
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      tablejoinData: [],
      newsInfo: [],
      parms: '',
      dialogFormVisible: false,
      dialogFormVisibles: false,
      dialogTableVisible: false,
      dataid: '',
      dataids: '',
      show1: false,
      fldsurface: 'dmcn_kyltenjoy',
      fldjoindata: 'dmcn_joinuser',
      checkData: '',
      userphone: '',
      userphone1: '',
      gridData: [],
      joinuserData: [],
      username: ''
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    this.username = userInfo.userno
    if (userInfo.role.indexOf(0) !== -1 || userInfo.role.indexOf(1) !== -1 || userInfo.role.indexOf(2) !== -1 || userInfo.role.indexOf(3) !== -1)
      this.show1 = true
    this.getList()
    this.getLists()
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      //循环筛选条件
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'title')
          exp += `A.name like '%${item}%' and `
      }
      exp = exp ? `${exp}A.id != 0` : 'A.id > 0'
      let paras = {cmd: 'queryUnion', _major: 11, _minor: 106, tables: 'A;B:11,105', cols: 'A:*;B:name as names', _exp: exp + ' and A.meetingid=B.id', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'id Desc'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              type: item.type,
              name: item.name,
              gender: item.gender,
              post: item.post,
              names: item.names,
              phone: item.phone,
              email: item.email,
              company: item.company,
              address: item.address,
              industrycategory: item.industrycategory,
              country: item.country,
              nums: item.nums,
              meetingtype: item.meetingtype,
              meetingid: item.meetingid,
              addtime: item.addtime,
              examine: item.examine,
              thumb: item.thumb,
              video: item.video,
              file: item.file,
              meetingdemand: item.meetingdemand
            })
          })
        }
      })
    },
    // 获取参会人员数据
    getLists()
    {
      // let count = this.form.count
      // let currentPage = this.currentPage
      // let exp = ''
      // //循环筛选条件
      // for (let e in this.form)
      // {
      //   let item = this.form[e]
      //   if (item && e === 'title')
      //     exp += `A.name like '%${item}%' and `
      // }
      // exp = exp ? `${exp}A.id != 0` : 'A.id > 0'
      let paras = {cmd: 'query', _major: 11, _minor: 120, _exp: 'id > 0', orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          this.tablejoinData = []
          ret.forEach((item) =>
          {
            this.tablejoinData.push({
              id: item.id,
              glid: item.glid,
              joinname: item.joinname,
              joingender: item.joingender,
              joinpost: item.joinpost,
              joinphone: item.joinphone
            })
          })
        }
      })
    },
    //点击通过
    release(row)
    {
      this.dialogFormVisible = true
      this.dataid = row.id
      this.userphone = row.phone
    },
    release1()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 106,
        retAtt: 1,
        id: this.dataid,
        examine: 1,
        reason: this.form.passcontent
      }
      let passDate = {
        cmd: 'smsNotice',
        _major: 99,
        _minor: 4,
        phone: this.userphone,
        key: 'signupAdopt'
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '操作失败', type: 'error', customClass: 'mzindex'})
        else
        {
          window.post.getDmSvr(passDate).then((ret) =>
          {
            this.$message({message: '操作成功', type: 'success', customClass: 'mzindex'})
            this.getList()
          })
        }
      })
      this.dialogFormVisible = false
    },
    //点击不通过
    releases(row)
    {
      this.dialogFormVisibles = true
      this.dataids = row.id
      this.userphone1 = row.phone
    },
    release2()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 106,
        retAtt: 1,
        id: this.dataids,
        examine: 2,
        reason: this.form.onpasscontent
      }
      let unpassDate = {
        cmd: 'smsNotice',
        _major: 99,
        _minor: 4,
        phone: this.userphone1,
        key: 'signupFail'
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '操作失败', type: 'error', customClass: 'mzindex'})
        else
        {
          window.post.getDmSvr(unpassDate).then((ret) =>
          {
            this.$message({message: '操作成功', type: 'success', customClass: 'mzindex'})
            this.getList()
          })
        }
      })
      this.dialogFormVisibles = false
    },
    // 点击导出
    load()
    {
      if (this.checkData)
      {
        let paras = {cmd: 'query', _major: 99, _minor: 5, _exp: `tabname = '${this.fldsurface}' and colname != 'reason' and colname != 'examine'`, orderby: 'disporder ASC'}
        let obj = {cmd: 'query', _major: 99, _minor: 5, _exp: `tabname = '${this.fldjoindata}'`, orderby: 'disporder ASC'}
        window.post.getPost(paras).then((ret) =>
        {
          window.post.getPost(obj).then((rets) =>
          {
            var param =
            {
              json: {0: this.checkData, 1: this.joinuserData},
              filename: '报名用户数据导出',
              columns: {0: {}, 1: {}},
              sheets: {0: '报名用户数据', 1: '参会人员数据'}
            }
            for (var fld of ret)
              param.columns[0][fld.colname] = fld.namec
            for (var flds of rets)
              param.columns[1][flds.colname] = flds.namec
            cx.expExcel.exportToSheets(param)
          })
        })
      }
      else
        this.$message({message: '请先选择要导出的用户', type: 'error', customClass: 'mzindex'})
    },
    // 全部导出
    loadAll()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 5, _exp: `tabname = '${this.fldsurface}' and colname != 'reason' and colname != 'examine'`, orderby: 'disporder ASC'}
      let obj = {cmd: 'query', _major: 99, _minor: 5, _exp: `tabname = '${this.fldjoindata}'`, orderby: 'disporder ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        window.post.getPost(obj).then((rets) =>
        {
          var param =
            {
              json: {0: this.tableData, 1: this.tablejoinData},
              filename: '报名用户数据导出',
              columns: {0: {}, 1: {}},
              sheets: {0: '报名用户数据', 1: '参会人员数据'}
            }
          for (var fld of ret)
            param.columns[0][fld.colname] = fld.namec
          for (var flds of rets)
            param.columns[1][flds.colname] = flds.namec
          cx.expExcel.exportToSheets(param)
        })
      })
    },
    // 打开图片
    openPicture(row)
    {
      if (row)
        window.open(row, '_blank')
      else
        this.$message({message: '该用户没有上传图片', type: 'error', customClass: 'mzindex'})
    },
    // 打开视频
    openVideo(row)
    {
      if (row)
        window.open(row, '_blank')
      else
        this.$message({message: '该用户没有上传视频', type: 'error', customClass: 'mzindex'})
    },
    // 打开文件
    openFile(row)
    {
      if (row)
        window.open(row, '_blank')
      else
        this.$message({message: '该用户没有上传文件', type: 'error', customClass: 'mzindex'})
    },
    openJoin(row)
    {
      if (row)
      {
        let paras = {cmd: 'query', _major: 11, _minor: 120, _exp: `glid = '${row.id}'`, orderby: 'id ASC'}
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length > 0)
          {
            this.dialogTableVisible = true
            this.gridData = []
            ret.forEach((item) =>
            {
              this.gridData.push({
                id: item.id,
                joinname: item.joinname,
                joingender: item.joingender,
                joinpost: item.joinpost,
                joinphone: item.joinphone
              })
            })
          }
          else
            this.$message({message: '该用户没有填写参会名单', type: 'error', customClass: 'mzindex'})
        })
      }
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/KyltMUpdate', query: {id: row.id}})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      this.checkData = val
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
      let paras = {cmd: 'query', _major: 11, _minor: 120, _exp: `glid in (${this.multipleSelection})`, orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)

          this.joinuserData = ret
      })
    },
    switchClick(val)
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 121,
        retAtt: 1,
        status: val,
        username: this.username,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '设置失败', type: 'error', customClass: 'mzindex'})
        else
          this.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
      })
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/UserEnrollLB.vue